import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {$agentsFactory} from "../../$agents.factory";

export class AgentSelectListComponent implements IController {

  options: any;
  selectedId: any;
  accountIds: string[];
  ngPlaceholder: any;
  excludeIds: any;
  onChange: Function;

  public excludedMap: any;
  private agentsRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;

  constructor(private $agents: $agentsFactory, private $infiniteScroll, private $log) {
  }

  $onInit() {
    if (!this.options) {
      this.agentsRef = this.$agents();
      this.loadLimit = 20;

      this.agentsRef.$query(this._getQueryPayload());
      this.infiniteScroll = this.$infiniteScroll(this.agentsRef, this.loadLimit, {getFullData: true});
    }
  }

  $onChanges(changes) {
    if (changes.excludeIds) {
      this.excludedMap = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludedMap[id] = true;
      })
    }
  }

  submitQuery(query) {
    this.queryString = query;
    if (!this.options) {
      this._reload();
    }
  }

  private _reload() {
    this.agentsRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.queryString,
      accountIds: this.accountIds || []
    };
  }
}

angular
  .module('bringoz.admin.agents')
  .component('agentSelectList', {
    bindings: {
      selectedId: '<',
      options :'<?',
      accountIds: '<?',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      onChange: '&'
    },
    template: require('./agent-select-list.html').default,
    controller: AgentSelectListComponent
  });
